import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp, PlusCircle } from "lucide-react";

interface HeaderProps {
  title: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  showToggleButton?: boolean;
  isFormVisible?: boolean;
  onToggleFormVisibility?: () => void;
}

const Header = ({
  title,
  buttonLabel,
  onButtonClick,
  showToggleButton = false,
  isFormVisible,
  onToggleFormVisibility,
}: HeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <div className="flex items-center gap-2">
        <h1 className="text-2xl font-semibold">{title}</h1>
        {showToggleButton && onToggleFormVisibility && (
          <Button
            type="button"
            variant="ghost"
            onClick={onToggleFormVisibility}
            className="flex items-center justify-center p-2 rounded-lg transition-all duration-200"
            aria-label={isFormVisible ? "Collapse form" : "Expand form"}
          >
            {isFormVisible ? (
              <ChevronUp className="h-10 w-10 text-blue-600 hover:text-blue-700" />
            ) : (
              <ChevronDown className="h-10 w-10 text-blue-600 hover:text-blue-700" />
            )}
          </Button>
        )}
      </div>
      {buttonLabel && (
        <Button
          className="mb-4 dark:bg-primary-500 bg-primary-500 text-background dark:text-white"
          onClick={onButtonClick}
        >
          <PlusCircle /> {buttonLabel}
        </Button>
      )}
    </div>
  );
};

export default Header;
